import { Jobs } from "./Jobs";

export class SignalREvents {
    public static readonly success: string = 'success';
    public static readonly warning: string = 'warning';
    public static readonly info: string = 'info';
    public static readonly error: string = 'error';

    public static readonly updateEasaAlert: string = 'UpdateEasaAlert';
    public static readonly updateStatusMaintenance: string = 'UpdateStatusMaintenance';
    public static readonly urgentErrorsChanged: string = 'urgentErrorsChanged';
    public static readonly urgentErrorsRPChanged: string = 'urgentErrorsRPChanged';
    public static readonly urgentFlightsChanged: string = 'urgentFlightsChanged';
    public static readonly sendMaintenanceNotification: string = 'SendMaintenanceNotification';
    public static readonly personRequestVacBlockChanged: string = 'personRequestVacBlockChanged';
    public static readonly personRequestVacAbsenceBlockChanged: string = 'personRequestVacAbsenceBlockChanged';
    public static readonly personRequestTzvBlockChanged: string = 'personRequestTzvBlockChanged';
    public static readonly personRequestReserveBlockChanged: string = 'personRequestReserveBlockChanged';
    public static readonly personRequestVacReportLineChangedAsync: string = 'personRequestVacReportLineChangedAsync';
    public static readonly personRequestReserveReportLineChanged: string = 'personRequestReserveReportLineChanged';
    public static readonly personRevalidationComplete: string = 'personRevalidationComplete';
    public static readonly refreshPersonRange: string = 'refreshPersonRange';
    public static readonly rosterHidePlanningPeriod: string = 'rosterHidePlanningPeriod';
    public static readonly rosterRefresh: string = 'rosterRefresh';
    public static readonly rosterPlanningRsvChanged: string = 'rosterPlanningRsvChanged';
    public static readonly jobStatusChanged: string = 'jobStatusChanged';
    public static readonly jobProgressMaxValueChanged: string = 'jobProgressMaxValueChanged';
    public static readonly jobProgressValueChanged: string = 'jobProgressValueChanged';
    public static readonly jobExportCompleted: string = 'jobExportCompleted';
    public static readonly jobMailStatusChanged: string = 'jobMailStatusChanged';
    public static readonly standByReportNotification: string = 'StandByReportNotification';
    public static readonly requestToolPointsNotification: string = 'requestToolPointsNotification';
    public static readonly requestToolGrantJobChangeStatus: string = 'requestToolGrantJobChangeStatus';
    public static readonly refreshPersonRequestFlight: string = 'refreshPersonRequestFlight';
    public static readonly refreshPersonRequestFlightStatus: string = 'refreshPersonRequestFlightStatus';
    public static readonly refreshPersonRequestAvailableFlight: string = 'refreshPersonRequestAvailableFlight';
    public static readonly refreshPersonRequestOff: string = 'refreshPersonRequestOff';
    public static readonly availableVacTypesChanged: string = 'availableVacTypesChanged';
    public static readonly sendJobTimeline: string = 'sendJobTimeline';
    public static readonly releaseHistoryStep: string = 'releaseHistoryStep';
    public static readonly sendApplyShadowDutiesJobProgressValue: string = 'sendApplyShadowDutiesJobProgressValue';
    public static readonly releaseHistoryResult: string = 'releaseHistoryResult';
    public static readonly changeLogNotification: string = 'changeLogNotification';
    public static readonly notifyFlightChanged: string = 'flightChanged';
    public static readonly rosterActivity: string = 'rosterActivity';
    public static readonly updatePersonConnection: string = 'updatePersonConnection';
    public static readonly simulationCourseChanged: string = 'simulationCourseChanged';
    public static readonly refreshPersonRequestReserve: string = 'refreshPersonRequestReserve';
    public static readonly aiExplainValidationMessageReply: string = 'aiExplainValidationMessageReply';
}

export class SignalRMethods {
    public static readonly updateRosterActivity: string = 'updateRosterActivity';
    public static readonly updatePersonIsActive: string = 'updatePersonIsActive';
    public static readonly updatePersonLastActivity: string = 'updatePersonLastActivity';
    public static readonly updatePersonLocation: string = 'updatePersonLocation';

    public static readonly explainValidationError: string = 'explainValidationError';
    public static readonly stopExplanation: string = 'stopExplanation';
}
export class SignalRGroups {
    public static readonly Job: string = ':Internal:JOB';
    public static readonly ChangeLog: string = ':Internal:CHANGE_LOG';
    public static readonly Roster: string = ':Internal:ROSTER';
    public static readonly RosterPlanningPeriod: string = ':Internal:ROSTER-PP';
    public static readonly RequestTimeline: string = ':Internal:REQUEST_TIMELINE';
    public static readonly ReleaseRoster: string = ':Internal:RELEASE_ROSTER';
    public static readonly StandByReport: string = ':Internal:STAND_BY_REPORT';
    public static readonly VacationManagment: string = ':Internal:VACATION_MANAGMENT';
    public static readonly ReserveManagment: string = ':Internal:RESERVE_MANAGMENT';
    public static readonly UrgentError: string = ':Internal:URGENT_ERROR';
    public static readonly RosterActivity: string = ':Internal:ROSTER_ACTIVITY';
    public static readonly ClientActivity: string = ':Internal:CLIENT_ACTIVITY';

    public static readonly RequestToolFlight: string = ':Internal:REQUEST_TOOL_FLIGHT';
    public static readonly RequestToolLtoStoFlight: string = ':Internal:REQUEST_TOOL_LTO_STO_FLIGHT';
    public static readonly RequestToolVacation: string = ':Internal:REQUEST_TOOL_VACATION';
    public static readonly RequestToolLtoSto: string = ':Internal:REQUEST_TOOL_LTO_STO';
    public static readonly RequestToolReserve: string = ':Internal:REQUEST_TOOL_RESERVE';
}

export class SignalRJobGroups {
    public static readonly CateringReport = `${SignalRGroups.Job}:${Jobs.CateringReportJob}`;
    public static readonly ExportCrewDutyListReport = `${SignalRGroups.Job}:${Jobs.ExportCrewDutyListJob}`;
    public static readonly ExportLogbook = `${SignalRGroups.Job}:${Jobs.ExportLogbookJob}`;
    public static readonly ReleaseScheduleJob = `${SignalRGroups.Job}:${Jobs.ReleaseScheduleJob}`;
    public static readonly SmsQueueJob = `${SignalRGroups.Job}:${Jobs.SmsQueueJob}`;
    public static readonly QualityLoopExport = `${SignalRGroups.Job}:${Jobs.QualityLoopExportJob}`;
    public static readonly PeriodPlanningJob = `${SignalRGroups.Job}:${Jobs.PeriodPlanningJob}`;
}

export class ComponentUrls {
    public static readonly HubUrl: string = '/hubs/notification';
    public static readonly QsImpersonatedPersonId: string = 'impersonate-p';
    public static readonly QsViewPersonId: string = 'view-p';
    public static readonly QsImpersonatedRoles: string = 'impersonate-r';
    public static readonly QsToken: string = 'token';
}
